/**
 * LangChain AsyncLocalStorage patch
 * This patches the specific issue where LangChain tries to use storage.getStore()
 */

// Create a robust AsyncLocalStorage implementation
class RobustAsyncLocalStorage {
  constructor() {
    this.store = null;
    this.contextStack = [];
  }
  
  run(store, callback, ...args) {
    const previousStore = this.store;
    this.store = store;
    this.contextStack.push(store);
    
    try {
      return callback(...args);
    } finally {
      this.contextStack.pop();
      this.store = previousStore;
    }
  }
  
  getStore() {
    return this.store || (this.contextStack.length > 0 ? this.contextStack[this.contextStack.length - 1] : null);
  }
  
  enterWith(store) {
    this.store = store;
    this.contextStack.push(store);
  }
  
  exit(callback, ...args) {
    const previousStore = this.store;
    this.store = null;
    
    try {
      return callback(...args);
    } finally {
      this.store = previousStore;
    }
  }
}

// Create global instance
const globalAsyncLocalStorage = new RobustAsyncLocalStorage();

// Patch any existing AsyncLocalStorage references
const patchAsyncLocalStorage = () => {
  // Override constructor
  if (typeof globalThis !== 'undefined') {
    globalThis.AsyncLocalStorage = RobustAsyncLocalStorage;
  }
  
  if (typeof window !== 'undefined') {
    window.AsyncLocalStorage = RobustAsyncLocalStorage;
  }
  
  // Patch any existing instances that might be cached
  try {
    // Look for LangChain's AsyncLocalStorage usage patterns
    const originalError = console.error;
    console.error = function(...args) {
      const message = args.join(' ');
      if (message.includes('storage.getStore is not a function')) {
        // Intercept and ignore this specific error
        return;
      }
      originalError.apply(console, args);
    };
  } catch (e) {
    // Ignore patching errors
  }
};

// Apply patch immediately and repeatedly
patchAsyncLocalStorage();
setInterval(patchAsyncLocalStorage, 1000);

export default RobustAsyncLocalStorage;